import { createContext, useState } from "react";

export interface EmailSelectedContextProps {
  selectedEmail: { email: string; color: string; checked?: boolean };
  setSelectedEmail: (option: any) => void;
}

export const EmailSelectedContext = createContext<EmailSelectedContextProps>({
  selectedEmail: { email: "", color: "" },
  setSelectedEmail: () => { },
});

export function EmailSelectedProvider(props: { children: React.ReactNode }) {
  const [selectedEmail, setSelectedEmail] = useState<{
    email: string;
    color: string;
    checked?: boolean;
  }>({ email: "", color: "" });

  return (
    <EmailSelectedContext.Provider value={{ selectedEmail, setSelectedEmail }}>
      {props.children}
    </EmailSelectedContext.Provider>
  );
} 
